import styled from 'styled-components';

export const FirstFormRowWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  padding: 0 0 5px;

  label {
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: var(--color-text-muted);
  }
`;
